export enum ActivityType {
  LIVE_CLASS = 'LIVE_CLASS',
  PRIVATE_CLASS = 'PRIVATE_CLASS',
  PRACTICE = 'PRACTICE',
  LESSON = 'LESSON',
  UNIT = 'UNIT',
  LEVEL = 'LEVEL',
  ACTIVE_HOURS = 'ACTIVE_HOURS',
}
